import { jordanDate, type RuleId } from '@serb/shared';
import { getSettings } from './settingsStore';

/** The number Ibraheem set in the rule book (days, or bookings) */
export const rule = (id: RuleId) => getSettings().rules[id];

/** Whole days from a date like 2026-10-15 to today in Jordan */
export const daysSince = (iso: string, today = jordanDate()) =>
  Math.round((Date.parse(today) - Date.parse(iso)) / 86_400_000);
